var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFinnTheHuman = function SvgIconFinnTheHuman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 14.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 13.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 8.375a4 4 0 0 0-4 4v1.5a4 4 0 0 0 4 4h7.5a4 4 0 0 0 4-4v-1.5a4 4 0 0 0-4-4zm-2 4a2 2 0 0 1 2-2h7.5a2 2 0 0 1 2 2v1.5a2 2 0 0 1-2 2h-7.5a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.125 2.75A3.25 3.25 0 0 0 .875 6v8.252a7.01 7.01 0 0 0 6.998 6.998h8.254a7.01 7.01 0 0 0 6.998-6.998V6a3.25 3.25 0 0 0-6.342-1H7.217a3.25 3.25 0 0 0-3.092-2.25m-.884 2.366A1.25 1.25 0 0 1 5.375 6a1 1 0 0 0 1 1h11.25a1 1 0 0 0 1-1 1.25 1.25 0 0 1 2.5 0v8.25a5.01 5.01 0 0 1-5.001 5H7.877a5.01 5.01 0 0 1-5.002-5V6c0-.332.132-.65.366-.884",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFinnTheHuman;